module.exports = __webpack_public_path__ + "static/umbu-rambu-2e993095d99d05158359921cf09b11bc.jpg";